import sme1 from '../assets/images/sme1.png';
import sme2 from '../assets/images/sme2.png';
import sme3 from '../assets/images/sme3.png';
import sme4 from '../assets/images/sme4.png';
import sme5 from '../assets/images/sme5.png';
import sme6 from '../assets/images/sme6.png';
import sme7 from '../assets/images/sme7.png';
import sme8 from '../assets/images/sme8.png';
import sme9 from '../assets/images/sme9.png';
import sme10 from '../assets/images/sme10.png';
import sme11 from '../assets/images/sme11.png';
import sme12 from '../assets/images/sme12.png';
import sme13 from '../assets/images/sme13.png';
import sme14 from '../assets/images/sme14.png';
import sme15 from '../assets/images/sme15.png';
import sme16 from '../assets/images/sme16.png';
import sme17 from '../assets/images/sme17.png';

export default [
  {
    sn: '01',
    img: sme1
  },
  {
    sn: '02',
    img: sme2
  },
  {
    sn: '03',
    img: sme3
  },
  {
    sn: '04',
    img: sme4
  },
  {
    sn: '05',
    img: sme5
  },
  {
    sn: '06',
    img: sme6
  },
  {
    sn: '07',
    img: sme7
  },
  {
    sn: '08',
    img: sme8
  },
  {
    sn: '09',
    img: sme9
  },
  {
    sn: '10',
    img: sme10
  },
  {
    sn: '11',
    img: sme11
  },
  {
    sn: '12',
    img: sme12
  },
  {
    sn: '13',
    img: sme13
  },
  {
    sn: '14',
    img: sme14
  },
  {
    sn: '15',
    img: sme15
  },
  {
    sn: '16',
    img: sme16
  },
  {
    sn: '17',
    img: sme17
  }
];
